// ############# Writing Guidance #############

// start with -- $h1$ -- for writing <h1></h1>
// start with -- $h2$ -- for writing <h2></h2>
// start with -- $a$<just link> -- for writing <a href=''></a>
// start with -- $code$<just link> -- for writing <code></code>
// start with -- $img$<link> -- for writing <img src='<link>'></img>
// start with -- $b$ -- for writing <p><strong></strong></p>
// start with -- $bq$ -- for writing <blockquote><p></p></blockquote>
// and nothing means <p></p>

export const DATA = [
  {
    path: "week-3",
    image: "week-3.jpg",
    title: "HTML Attributes",
    week: "3",
    date: "10 March, 2022",
    content: [
      `$h1$What are attributes?`,
      `In an easy way, it's the first creepy thing you will learn in HTML that won't make any sense at the time. Because, well it doesn't affect much for most of them.`,
      `But for some, it's necessary like \`img\`, \`a\`, etc.`,
      `In a professional way, as a web developer, we develop code for vast fo people and we need a beautiful and interactive website that a user will love. So we use them.`,
      `I will talk about the common attributes,`,
      `$h2$\`src\` and \`alt\``,
      `\`src\` is an essential attribute for the \`<audio>, <embed>, <iframe>, <img>, <input>, <script>, <source>, <track>, <video>\` tag to function. So in \`img\` tag, we use something like this \`<img src="my_image.png" alt="" >\` So, \`src\` use for mentioning the URL for the image. And don't forget to use a descriptive \`alt\` tag, because if anything goes wrong with the URL it will show the text instead. So finally It will look something like this \`<img src="my_image.png" alt="a demo image" >\`. Another reason for using \`alt\` text is, the people uses a browser reader for their browsing experience the browser reader reads the \`alt\` text for an \`img\` tag.`,
      `$h2$\`href\``,
      `It is necessary for the \`a\` tag to work. It defines the address you will be going after clicking the text within an \`a\` tag. So, we use it like \`<a href="https://ah-jim-seed.web.app/">my website</a>\`.`,
      `$h2$class and id`,
      `Oh man, These are the most common day-to-day used attributes for you as a web developer. You will use them to style an element or make that interactive. You can use in any HTML element in the opening tag like \`<tagName class="" id="">\` ie, \`<div class="demo__class" id="unique_ID">\`. One thing to keep in mind here, the \`class\` can be repeatable on the page but the \`id\`s should be unique on that particular page and they are not required to write HTML code.`,
      `$h2$height, width, and style`,
      `These are optional and you use them in any of the tags, you can use in the \`body\` tag. So, height defines the right of that element, width defines the width, and style let you use CSS within the tag itself. you can write them this way \`<p height="100px" width="20px" style="color: red;">...</p>\``,
      `$h2$lang`,
      `Lang is used to defining the language used in the element. The value are language code, it can be used as \`<html lang="en">\`.`,
      `In the \`head\` tag we use different sets of tags and attributes we will discuss them next week.`,
    ],
  },
  {
    path: "week-2",
    image: "week-2.jpg",
    title: "Tag Breakdown🧱",
    week: "2",
    date: "1 February, 2022",
    content: [
      `Have you wondered, why are we writing HTML elements like <p>...</p> or some structure like that?`,
      `And what the cr*p is an HTML element, in the first place?`,
      `Let me demonstrate first for an example,`,
      `$code$<p>My Cat is very grumpy</p>`,
      `$img$/image/week-2/img_1.png`,
      `$b$Opening tag:`,
      `It instructs a browser, "Hey you, now start reading content after me as a paragraph, or whatever the tag I meant for."`,
      `So, as `,
      `$bq$Browsers read from Top to Bottom & Left to Right.`,
      `$b$Content: `,
      `This is the part we, as a user or viewer see. So, the letters you are seeing as a word and sentence, is the part that is written as content in HTML.`,
      `$b$Closing Tag: `,
      `This is the sign for browsers that, "You have done a good job, now you can stop reading content as paragraph and move on for next instruction."`,
      ` So, let's back to the second question: What an HTML element is?`,
      `So, in general,`,
      `$bq$The consistency of the opening tag, content, and closing tag is called an HTML element.`,
      `But, that's not the only way of writing an element. Elements can be a lot more complex and nested in other elements. Like, hope you remembered from the last week <h1> tag and <p> tag was inside <body> tag/element. And we can nest other tags as well, like:`,
      `$code$<p>My cat is <strong>very grumpy.</strong></p>`,
      `But, there is some tag/element that don't need content or closing tag, ie:`,
      `$code$<img src="image.jpg" alt="" >`,
      `This tag is used for showing an image. So, this will be an image element, but it doesn't need any content or closing tag. It's called a self-closing tag (But there is a lot. So we will dedicate our week to the image element later on.)`,
      `And tag uses attributes simply for their name or some complex instruction or accessibility. We will be discussing those in the next week so till then, stay safe.`,
    ],
  },
  {
    path: "week-1",
    image: "week-1.jpg",
    title: "HTML Anatomy🧍🏽‍♂️",
    week: "1",
    date: "24 January, 2022",
    content: [
      `As HTML is the soul of the web, we must know how it works (we will focus on writing HTML).`,
      `Even though the HTML has different versions in his family, we only speak in the updated version, which is HTML5. So let's start wondering about HTML5.`,
      `So this is the basic HTML page structure:`,
      `$code$<!DOCTYPE html>`,
      `$code$<html>`,
      `$code$<head>`,
      `$code$<title>Title of the Page</title>`,
      `$code$</head>`,
      `$code$<body>`,
      `$code$<h1>A Heading</h1>`,
      `$code$<p>A paragraph.</p>`,
      `$code$</body>`,
      `$code$</html>`,
      `There you go with your first HTML code.`,
      `But wait a minute 😗, what is that? I got the 'Title of the Page', 'A Heading', and 'A Paragraph', but what are those in <..>..</..>?`,
      `Right these are HTML tags. Let me break it down.`,
      `First,`,
      `$code$<!DOCTYPE html>`,
      `is telling the browser, "Hey, look, I am an HTML5 document. So don't try to read me like other versions of my family, Just read me like me (HTML5)".`,
      `So, the browser hears the soul and reads the rest.`,
      `Then,`,
      `$code$<html></html>`,
      `This tag is the root element of the HTML page. So whatever you are seeing right now is in between this tag.`,
      `Next, we have,`,
      `$code$<head></head>`,
      `Which tells the browser some useful information about your website/page that you and I don't see so often. In between, we declare the title, description, keywords that appear in the search result. It also holds the CSS and JavaScript contents, character set declarations, and more. Which we will be discussing later on. let's move on to the`,
      `$code$<title></title>`,
      `tag. Oh, man! Shouldn't you give your page a name? And if you are saving the page to the bookmark, what is the name your browser should remember(save)/reference it? So this is how the web knows the name of your web or HTML page. Like`,
      `$img$/image/week-1/bar.png`,
      `Oh, that's a lot we don't see, do we?`,
      `Now, time to discover what viewers are seeing on the website.`,
      `$code$<body></body>`,
      `This tag tells the browser, "Browser, listen, I've given you a lot of information that viewers can't see. Now whatever declared in between me, show that to the viewers."`,
      `Let's declare some,`,
      `$code$<h1>A Heading</h1>`,
      `$code$ `,
      `$code$<p>A paragraph.</p>`,
      `Which gives us,`,
      `$img$/image/week-1/body.png`,
      `With <h1></h1> you the browser give me a big size of heading.`,
      `And with <p></p> you just declared a simple text.`,
      `Note, Html doesn't care about extra spaces. Extra spaces will be removed automatically by the browser.`,
      `With everything we just discussed, the web page looks like,`,
      `$img$/image/week-1/basic.png`,
      `To know even more, visit: `,
      `$a$https://developer.mozilla.org/en-US/docs/Learn/HTML/Introduction_to_HTML/Getting_started`,
    ],
  },
  {
    path: "week-0",
    image: "introduction.jpg",
    title: "Introduction",
    week: "0",
    date: "17 January, 2022",
    content: [
      `$h1$What is HTML?`,
      `🙄🙄 Are you Kidding! In this century, where everything is on the web,
      and you cannot do anything without it, and now, you are saying that
      you are not familiar with HTML!`,
      `Whatever, Let me tell you. HTML is the soul of the web. All the
      contents you are seeing are built using HTML. It's the core. So, you
      can code a website by not using any style(CSS) or
      interactivity(JavaScript) But not without HTML.`,
      `$h2$Okay, So who created this?`,
      `HTML was created by Sir Tim Berners-Lee in late 1991 but was not
      released officially, published in 1995 as HTML 2.0.`,
      `HTML 4.01 was published in late 1999 and was a major version of HTML.`,
      `And currently, we all are using HTML5 for creating a website. But as
      it is not a History lesson, and obviously I am not a History Teacher,
      I am not going over all the detailed History. But you can check
      people's who love to write those, Like this one:`,
      `$a$https://en.wikipedia.org/wiki/HTML`,
      `Okay, so now that you know what HTML is, why the h*ll I am dedicating
      a newsletter about this?`,
      `As this is the building block of the web, I think it would be great to
      share its different options(tags) in easy and fun words for you to
      use.`,
      `In this weekly newsletter series, I will be writing about different
      tags and how you can use them with some examples.`,
      `So, buckle up, and Let's get started.`,
    ],
  },
];
